import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MoIcon extends Vue {
  @Prop(String)
  icon: string
}
